
import { Vue, Component, Prop } from 'vue-property-decorator';
import TopBar from '@/components/TopBar.vue';
import ChapterIntro from '@/components/ChapterIntro.vue';
import ChapterSurvey from '@/components/ChapterSurvey.vue';
import {MutationType, RouteName} from '@/enums';
import BackButton from "@/components/BackButton.vue";

@Component({
	components: {
		BackButton,
		TopBar,
		ChapterIntro,
		ChapterSurvey
	}
})
export default class Chapter extends Vue {
	private get domainLabel(): string {
		return this.$store.state.currentDomain.label;
	}

	private clickBackButton(): void {
		this.$router.push({
			name: RouteName.OVERVIEW
		});
	}

	beforeMount() {
		const domainId = parseInt(this.$route.params.domainId, 10);
		const chapterId = parseInt(this.$route.params.chapterId, 10);

		this.$store.commit(MutationType.SET_CURRENT_DOMAIN, this.$store.state.domains[domainId]);
		this.$store.commit(MutationType.SET_CURRENT_CHAPTER, this.$store.state.domains[domainId].chapters[chapterId]);
	}
}
